module.exports = require("diff-match-patch");